import React from "react";
import { formatMoney } from "../lib/partnerPricing";

function pickAmount(...candidates) {
  for (const c of candidates) {
    if (c == null || c === "") continue;
    const n = Number(c);
    if (Number.isFinite(n)) return n;
  }
  return null;
}

/** Compact trip quote summary for the Ace agent panel. */
export default function ChatQuoteCard({ quote }) {
  if (!quote || typeof quote !== "object") return null;

  const breakdown = quote.price_breakdown || {};
  const subtotal = pickAmount(quote.subtotal);
  const taxesFees = pickAmount(
    quote.taxes_and_fees,
    quote.other_fees,
    breakdown.taxes_and_fees,
    breakdown.other_fees,
    breakdown.platform_fee,
  );
  const deposit = pickAmount(quote.deposit_amount, quote.deposit);
  const total = pickAmount(quote.amount_due, quote.total, quote.estimated_total);
  const insurance = quote.insurance;
  const showInsurance = insurance != null || quote.insurance_label || quote.insurance_status;
  const insuranceLabel = quote.insurance_label
    || (typeof insurance === "object" && insurance?.label)
    || "Insurance";
  const insuranceValue = quote.insurance_value
    || quote.insurance_status
    || (typeof insurance === "object" && insurance?.included !== false ? "Included" : null)
    || (typeof insurance === "string" ? insurance : null)
    || "Included";

  const rows = [
    subtotal != null && { key: "subtotal", label: "Subtotal", value: formatMoney(subtotal) },
    taxesFees != null && { key: "fees", label: "Taxes & fees", value: formatMoney(taxesFees) },
    deposit != null && deposit > 0 && { key: "deposit", label: "Deposit", value: formatMoney(deposit) },
    showInsurance && { key: "insurance", label: insuranceLabel, value: insuranceValue },
    total != null && { key: "total", label: quote.amount_due != null ? "Amount due" : "Total", value: formatMoney(total), emph: true },
  ].filter(Boolean);

  if (!rows.length) return null;

  return (
    <div
      className="mt-3 rounded-[12px] border border-[var(--zc-border)] bg-[var(--zc-bg-3)] p-3 space-y-1.5"
      data-testid="ai-chat-quote"
    >
      <div className="eyebrow text-[var(--zc-text-3)]">Trip quote</div>
      {rows.map((row) => (
        <div
          key={row.key}
          className={"flex items-baseline justify-between gap-3 text-xs " +
            (row.emph ? "font-semibold text-[var(--zc-text)] pt-1 border-t border-[var(--zc-border)]" : "text-[var(--zc-text-2)]")}
        >
          <span>{row.label}</span>
          <span className="tabular-nums shrink-0">{row.value}</span>
        </div>
      ))}
    </div>
  );
}
